<template>
  <div>
    <div
      class="BillingRecords"
      v-if="page==='list'"
    >
      <el-card class="box-card">
        <div
          slot="header"
          class="clearfix"
        >
          <el-select
            v-model="appKeyvalue"
            clearable
            placeholder="选择AppKey"
          >
            <el-option
              v-for="item in appKeyList"
              :key="item.value"
              :label="item.name"
              :value="item.app_key"
            >
            </el-option>
          </el-select>
          <el-input
            placeholder="请输入Api名称"
            v-model="apiName"
            class="input-with-select"
            style=" margin-left: 15px; width: 250px;"
          >
          </el-input>
          <el-date-picker
            v-model="time"
            type="daterange"
            style=" margin:0 15px;"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="selectTime"
          >
          </el-date-picker>
          <el-button
            @click="clear"
            id="clearBtn"
          >重置</el-button>
          <el-button
            @click="getmyApiList()"
            id="searchBtn"
            type="primary"
          >查询</el-button>
          <el-button
            style="float: right; "
            type="danger"
            @click="ViewBuy()"
          >购买套餐</el-button>
        </div>
        <div>
          <el-table
            style="width: 100%"
            :data="tableData"
            :header-cell-style="tableHeaderColor"
            :default-sort="{prop: 'date', order: 'descending'}"
          >
            <el-table-column
              prop="id"
              label="ID"
              width="80"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              label="接口名称"
              width="200"
            >
            </el-table-column>
            <el-table-column
              prop="app_key"
              label="Appkey"
              width="160"
            >
            </el-table-column>
            <el-table-column label="收费模式" width="140">
              <template slot-scope="scope">
                <span v-if="scope.row.fee_way==0">按次收费</span>
                <span v-if="scope.row.fee_way==1">一次性收费</span>
                <span v-if="scope.row.fee_way==3">按年收费</span>
              </template>
            </el-table-column>
            <el-table-column label="套餐信息" width="240">
              <template slot-scope="scope">
                <div v-if="scope.row.fee_way==0">
                  <span>剩余/总次数：</span>
                  <span>{{scope.row.left_num}}次/{{scope.row.left_num}}次</span>
                </div>
                <span v-if="scope.row.fee_way==1">无期限</span>
                <span v-if="scope.row.fee_way==3">到期时间：{{scope.row.expire_time}}</span>
              </template>
            </el-table-column>
            <el-table-column sortable label="到期时间" width="180">
              <template slot-scope="scope">
                <span >{{scope.row.expire_time || '---'}}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="create_time"
              sortable
              label="创建时间"
              width="180"
            >
            </el-table-column>
            <el-table-column
              prop="update_time"
              sortable
              label="更新时间"
              width="180"
            >
            </el-table-column>
            <el-table-column label="状态" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 0">正常</span>
                <span v-if="scope.row.status === 1">失效</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="100">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                >使用详情</el-button>

              </template>
            </el-table-column>
          </el-table>
          <div class="pager">
            <el-pagination
              background
              :page-size="pagesize"
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :total="totalcount"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
    <buy
      v-if="page==='buy'"
      @watchson="getchildmsg"
    >
      <BreadcrumbBack
        class="bread"
        :navs="navs"
      />
    </buy>

    <el-dialog
      width="80%"
      :show-close="false"
      :visible.sync="dialogFormVisible"
    >
      <i
        class="el-icon-close"
        @click="closeDialog"
      ></i>
      <use-detail
        v-if="page==='detail'"
        :appkey="appkey"
        :apiId="apiId"
      ></use-detail>

    </el-dialog>

  </div>

</template>
<script>
import Buy from './Buy.vue';
import BreadcrumbBack from '@/tools/BreadcrumbBack'

import apis from "@/api/apis";
import UseDetail from './UseDetail.vue';
export default {
  components: { Buy, BreadcrumbBack, UseDetail },
  name: 'myApi',
  data () {
    return {
      time: '',
      dialogFormVisible: false,
      appKeyvalue: '',
      date: '',
      page: 'list',
      pagesize: 10,
      pagenum: 1,
      totalcount: 0,
      startTime: '',
      endTime: '',
      tableData: [],
      appKeyList: [],
      appkey: Number,
      dialogList: [],
      apiName: '',
      apiId: ''


    };
  },
  computed: {
    navs () {
      return [
        {
          title: '我的接口',
          onClick: () => { this.page = 'list';this.$router.push({name:'MyInterface', query:{}}) }
        },
        {
          title: '购买套餐'
        }
      ]
    },
    paymentNavs () {
      return [
        {
          title: '我的接口',
          onClick: () => { this.page = 'list' }
        },
        {
          title: '购买套餐',
          onClick: () => { this.page = 'buy' }
        },
        {
          title: '支付'
        }
      ]
    },
    useDetailList () {
      return [
        {
          title: '我的接口',
          onClick: () => { this.page = 'list' }
        },
        {
          title: '使用详情',
        },

      ]
    },

  },
  created() {
    if (this.$route.query.buyApiId) {
      this.page = 'buy'
    }
  },
  mounted () {
    this.getmyApiList()
  },
  methods: {
    handleCurrentChange (val) {
      this.pagenum = val
      this.getmyApiList()
    },
    //我的接口
    getmyApiList () {
      apis.index.myApiList({
        name: this.apiName,
        start_time: this.startTime,
        end_time: this.endTime,
        app_key: this.appKeyvalue,
        page: this.pagenum,
        page_size: this.pagesize,
      }).then(res => {
        this.tableData = res.data.list
        this.totalcount = parseInt(res.data.count)
        this.getAppDetail()
      })
      document.getElementById("searchBtn").blur()
    },
    //appkey列表
    getAppDetail () {
      apis.app.index({
        page: 1,
        page_size: 100,
      }).then(res => {
        this.appKeyList = res.data.list
      })
    },
    getchildmsg (res) {
      console.log(res, "jumpjumpjump");
      this.page = res
      this.getmyApiList()
    },
    ViewBuy () {
      this.page = 'buy'
    },
    tableHeaderColor ({ rowIndex, }) {
      if (rowIndex === 0) {
        return 'background-color: #FAFAFA;color: #000;font-weight: 500;'
      }
    },
    clear () {
      this.apiName = []
      this.startTime = []
      this.endTime = []
      this.appKeyvalue = []
      this.time = []
      this.getmyApiList()
      document.getElementById("clearBtn").blur()
    },
    //选择时间
    selectTime () {
      this.startTime = this.filterTime(this.time[0])
      this.endTime = this.filterTime(this.time[1])
    },
    //中国标准时间转换格式
    filterTime (time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      /* var h = date.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var s = date.getSeconds();
      s = s < 10 ? "0" + s : s; */
      return y + "-" + m + "-" + d /* + " " + h + ":" + minute + ":" + s */;
    },
    handleChange (val) {
      this.pagenum = val
      this.getUseDetail()
    },
    handleClick (row) {
      this.appkey = row.app_key
      this.apiId = row.api_id
      this.page = 'detail'
      this.dialogFormVisible = true
    },
    closeDialog () {
      this.dialogFormVisible = false
      this.page = 'list'
    },
  }
}
</script>
<style lang="scss" scoped>
.el-dialog {
  position: relative;
  i {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
  }
}
::v-deep .el-dialog__body {
  padding: 0;
}
::v-deep .el-dialog__header {
  padding: 0;
  height: 0 !important;
  background: #fff !important;
}
.bread {
  margin-bottom: 16px;
}
.box-card {
  padding: 10px;
  background: #ffffff;
  .clearfix {
    /* display: flex; */
  }
  .clearfix:before,
  .clearfix:after {
    display: table;
    content: '';
  }
  .clearfix:after {
    clear: both;
  }
  .pager {
    margin-top: 10px;
    width: 100%;
    height: 64px;
    background: #ffffff;
    padding-right: 30px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>